import { responsiveFontSizes, Theme } from "@mui/material/styles";
import themeV4 from "../themeV4";

const queryBuilderTheme: Theme = {
  ...themeV4,
};

export default responsiveFontSizes(queryBuilderTheme);
